import { format } from "react-string-format";

type MessageList = { [x: string]: string };

export const getFormError = (key: string, ...param: string[]): string => {
  return getMessage(formErrors, key, false, ...param);
};

export const getServerError = (key: string, ...param: string[]): string => {
  return getMessage(serverErrors, key, true, ...param);
};

export const getClientError = (key: string, ...param: string[]): string => {
  return getMessage(clientErrors, key, true, ...param);
};

export const getClientMessage = (key: string, ...param: string[]): string => {
  return getMessage(clientMessages, key, false, ...param);
};

const getMessage = (
  list: MessageList,
  key: string,
  displayKey: boolean,
  ...param: string[]
): string => {
  if (typeof key === "undefined") return "エラーコードが取得できません。";
  let message = "メッセージが設定されていません。";
  if (key in list) {
    message = list[key];
  }
  if (displayKey) {
    return format(`[${key}] ${message}`, ...param);
  }
  return format(message, ...param);
};

const formErrors: MessageList = {
  required: "{0}: 入力されていません。",
  date: "{0}: 正しい日付が入力されていません。",
};

const clientErrors: MessageList = {
  B000010_001: "一定期間操作されなかったため、ログインを行ってください。",
  B000150_001:
    "得意先支店コードのみの入力はできません。得意先コードを入力して下さい",
  B000150_002: "得意先コードか得意先支店コードの開始を入力して下さい",
  B010010_001: "受注数には0より大きい値を入力してください。",
  B010010_002: "掛率には0～999までの整数値を入力してください。",
  B010010_003: "受注金額が9桁以内になるよう、値を調整してください。",
  B010010_004: "上代の合計金額が9桁以内になるよう、値を調整してください。",
  B010010_005: "下代の合計金額が9桁以内になるよう、値を調整してください。",
  B010010_006: "入力された商品は材料品のため使用できません。",
  B010010_007: "物流倉庫、引当倉庫以外は使用できません。",
  B010010_008: "外寸Wが入力されていません。",
  B010010_009: "外寸Hが入力されていません。",
  B010010_010: "外寸Wには0より大きい値を入力してください。",
  B010010_011: "外寸Hには0より大きい値を入力してください。",
  B010010_012: "内寸Wが入力されていません。",
  B010010_013: "内寸Hが入力されていません。",
  B010010_016: "受注生産品で外寸WHが入力されていません。",
  B010010_017: "在庫がありません。",
  B010012_001: "受注数には0より大きい値を入力してください",
  B010012_002: "入力された商品は材料品のため使用できません。",
  B010012_003: "物流倉庫、引当倉庫以外は使用できません。",
  B010012_004: "外寸Wが入力されていません。",
  B010012_005: "外寸Hが入力されていません。",
  B010012_006: "外寸Wには0より大きい値を入力してください。",
  B010012_007: "外寸Hには0より大きい値を入力してください。",
  B010012_008: "内寸Wが入力されていません。",
  B010012_009: "内寸Hが入力されていません。",
  B010012_012: "上代の合計金額が9桁以内になるよう、値を調整してください。",
  B010012_013: "下代の合計金額が9桁以内になるよう、値を調整してください。",
  B010012_014: "入力された商品はセット商品のため使用できません。",
  B010012_015: "受注生産品で外寸WHが入力されていません。",
  B010012_016: "在庫がありません。",

  B010050_001: "受注データファイルの取込に失敗しました。",
  B010060_001: "受注数には0より大きい値を入力してください。",
  B010060_002: "掛率には0～999までの整数値を入力してください。",
  B010060_003: "受注金額が9桁以内になるよう、値を調整してください。",
  B010060_004: "上代の合計金額が9桁以内になるよう、値を調整してください。",
  B010060_005: "下代の合計金額が9桁以内になるよう、値を調整してください。",
  B010060_006: "入力された商品は材料品のため使用できません。",
  B010060_007: "物流倉庫、引当倉庫以外は使用できません。",
  B010060_008: "外寸Wが入力されていません。",
  B010060_009: "外寸Hが入力されていません。",
  B010060_010: "外寸Wには0より大きい値を入力してください。",
  B010060_011: "外寸Hには0より大きい値を入力してください。",
  B010060_012: "内寸Wが入力されていません。",
  B010060_013: "内寸Hが入力されていません。",
  B010060_016: "受注生産品で外寸WHが入力されていません。",
  B010070_001:
    "全ての商品が在庫不足のためスキップした受注があります(行番号{0})",

  B020010_001: "登録可能な行数を超えています。",
  B020010_002: "外寸Wが入力されていません。",
  B020010_003: "外寸Hが入力されていません。",
  B020010_004: "外寸Wには0より大きい値を入力してください。",
  B020010_005: "外寸Hには0より大きい値を入力してください。",
  B020010_006: "内寸Wが入力されていません。",
  B020010_007: "内寸Hが入力されていません。",
  B020010_010: "編集中の内訳区分と明細の内訳区分が一致しません。",
  B020010_011: "明細に登録されている内訳区分と一致しません。",
  B020010_012:
    "商品種別区分が受注生産ではないため、倉庫コードを入力してください。",
  B020010_013: "上代の合計金額が9桁以内になるよう、値を調整してください。",
  B020010_014: "下代の合計金額が9桁以内になるよう、値を調整してください。",
  B020010_015: "売上数がマイナスです。",
  B020010_016: "倉庫が物流倉庫ではありません。",
  B020010_017: "倉庫がその他倉庫ではありません。",
  B020010_018: "倉庫が返品倉庫ではありません。",
  B020010_019: "在庫がありません。",
  B020010_020: "受注生産品で外寸WHが入力されていません。",
  B020010_021: "入力された商品は材料品のため使用できません。",
  B020010_022: "売上数には0以外の値を入力してください。",

  B020012_001: "外寸Wが入力されていません。",
  B020012_002: "外寸Hが入力されていません。",
  B020012_003: "外寸Wには0より大きい値を入力してください。",
  B020012_004: "外寸Hには0より大きい値を入力してください。",
  B020012_005: "内寸Wが入力されていません。",
  B020012_006: "内寸Hが入力されていません。",
  B020012_009: "倉庫コードを入力して下さい。",
  B020012_010: "上代の合計金額が9桁以内になるよう、値を調整してください。",
  B020012_011: "下代の合計金額が9桁以内になるよう、値を調整してください。",
  B020012_012: "物流倉庫以外は使用できません。",
  B020012_013: "その他倉庫以外は使用できません。",
  B020012_014: "返品倉庫以外は使用できません。",
  B020012_015: "在庫がありません。",
  B020012_016: "売上数には0より大きい値を入力してください。",
  B020012_017: "入力された商品はセット商品のため使用できません。",
  B020012_018: "物理倉庫は使用できません。",
  B020012_019: "受注生産品で外寸WHが入力されていません。",

  B030050_001: "入金日が入力されていません。",
  B030050_002: "請求先コードが入力されていません。",
  B030050_003: "請求先支店コードが入力されていません。",
  B030050_004: "売掛金担当者コードが入力されていません。",
  B030050_005:
    "入金伝票番号が設定されておらず明細行が存在しないため、この操作を行うことはできません。",
  B030050_006: "内訳区分が選択されていません。",
  B030050_007: "入金合計額が入力されていません。",
  B030050_008: "銀行コードが入力されていません。",
  B030050_009: "手形番号が入力されていません。",
  B030050_010: "手形種別が入力されていません。",
  B030050_011: "手形振出日が入力されていません。",
  B030050_012: "手形決済日が入力されていません。",

  B030060_001: "対象年月が入力されていません。",

  B040010_001: "発注日 ≦ 希望納期で指定してください。",
  B040010_002: "発注数を入力してください。",
  B040010_003: "発注単価を入力してください。",
  B040010_006: "入荷された発注明細データです。",

  B050010_001: "仕入数を入力してください。",
  B050010_002: "仕入単価を入力してください。",
  B050010_003: "仕入数は入力できません。",
  B050010_004: "仕入単価は入力できません。",
  B050010_005: "在庫がありません。",
  B050010_006: "その他倉庫以外の倉庫コードは入力できません。",

  B050020_001: "仕入入力の権限がないため詳細画面へ移動できません。",

  B050030_001: "仕入入力の権限がないため詳細画面へ移動できません。",

  B060010_001: "検索条件に一致するデータは存在しません。",
  B060010_002: "EXCEL出力するデータが存在しません。",
  B060020_001: "EXCEL出力するデータが存在しません。",
  B060030_001: "EXCEL出力するデータが存在しません。",

  B080020_001: "指定された検索条件に合致するデータは存在しません。",

  B080030_001: "指定された検索条件に合致するデータは存在しません。",

  B080040_001: "指定された検索条件に合致するデータは存在しません。",

  B080050_001: "訂正する行の出荷確定数を入力してください。",
  B080050_002: "出荷確定数が出荷予定数を超過しています。",

  B080060_001: "指定された検索条件に合致するデータは存在しません。",

  B080070_001: "指定された検索条件に合致するデータは存在しません。",

  B080080_001: "該当データがありません。",

  B080090_001: "指定された検索条件に合致するデータは存在しません。",

  B090010_001: "商品、JANコード、倉庫、倉庫種別のいずれかを入力してください。",
  B090010_002: "指定された検索条件に合致するデータは存在しません。",

  B090011_001: "指定された検索条件に合致するデータは存在しません。",

  B090020_001: "払出倉庫コードと受入倉庫コードが同じです。",
  B090020_002: "払出倉庫には論理倉庫と引当倉庫のみ指定できます。",
  B090020_003: "受入倉庫には論理倉庫と引当倉庫のみ指定できます。",
  B090020_004: "払出倉庫と受入倉庫がどちらも引当倉庫です。",
  B090020_005: "商品コードと移動数を入力してください。",
  B090020_006: "すでにその商品が存在します。",
  B090020_007: "移動数は可能数よりも大きい値を指定できません。",
  B090020_008: "移動数は 0 以上を入力してください。",

  B090021_001: "受入倉庫には返品倉庫とその他倉庫のみ指定できます。",
  B090021_002: "商品コードと移動数を入力してください。",
  B090021_003: "すでにその商品が存在します。",
  B090021_004: "移動数は可能数よりも大きい値を指定できません。",
  B090021_005: "移動数は 0 以上を入力してください。",
  B090021_006: "受入倉庫には返品倉庫とその他倉庫のみ指定できます。",

  B090030_001: "商品コードを入力してください。",
  B090030_002: "払出ロケーションコードを入力してください。",
  B090030_003: "受入ロケーションコードを入力してください。",
  B090030_004: "移動数を入力してください。",
  B090030_005: "払出ロケーションコードと受入ロケーションコードが同じです。",
  B090030_006:
    "すでに明細部に同じ払出ロケーションコードを持つ商品が存在します。",
  B090030_007: "移動数は0よりも大きい数を入力して下さい",
  B090030_008: "移動数は可能数よりも小さい値を入力してください。",

  B090040_001:
    "入力された倉庫は物理倉庫・材料倉庫・返品倉庫・その他倉庫のいずれでもありません。",
  B090040_002: "調整区分が選択されていません。",
  B090040_003: "商品コードが入力されていません。",
  B090040_004: "倉庫コードが入力されていません。",
  B090040_005: "ロケーションコードが入力されていません。",
  B090040_006: "調整数が入力されていません。",
  B090040_007: "0以下の数値を調整数に設定することは出来ません。",
  B090040_008: "調整日が入力されていません。",
  B090040_009: "担当者コードが入力されていません。",

  B090050_001: "更新日時の範囲指定「時間(開始)」が存在しない時刻です。",
  B090050_002: "更新日時の範囲指定「分(開始)」が存在しない時刻です。",
  B090050_003: "更新日時の範囲指定「時間(終了)」が存在しない時刻です。",
  B090050_004: "更新日時の範囲指定「分(終了)」が存在しない時刻です。",
  B090050_005: "検索条件に一致するデータは存在しません。",

  B090051_001: "更新日時の範囲指定「時間(開始)」が存在しない時刻です。",
  B090051_002: "更新日時の範囲指定「分(開始)」が存在しない時刻です。",
  B090051_003: "更新日時の範囲指定「時間(終了)」が存在しない時刻です。",
  B090051_004: "更新日時の範囲指定「分(終了)」が存在しない時刻です。",
  B090051_005: "検索条件に一致するデータは存在しません。",

  B100070_001:
    "標準納入先を 0 件にすることは出来ません。他の納入先を標準に変更してください。",
  B100070_002:
    "標準納入先を削除することは出来ません。他の納入先を標準に変更後に削除してください。",

  B100120_001: "商品中分類指定時は大分類も入力して下さい。",
  B100120_002: "商品小分類指定時は大分類と中分類も入力して下さい。",
  B110030_001: "伝票日付は同月内で指定してください。",
};

const commonMessages: MessageList = {
  DOWNLOADED: "ダウンロードが完了しました。",
  PRINTING: "処理が完了しました。",
};

const clientMessages: MessageList = {
  B010010_001: "受注伝票番号 {0} を登録しました。",
  B010010_002: "受注データを更新しました。",
  B010020_001: "受注キャンセルが完了しました。",
  B010040_001: commonMessages.DOWNLOADED,
  B010050_001: "受注データファイルのチェックを開始します。",
  B010050_002: "受注データファイルのチェックが正常に終了しました。",
  B010060_001: "受注ワーク入力を更新しました。",
  B010070_001: "受注ワークデータを削除しました。",
  B010070_002: "受注ワークデータを反映しました。",
  B010070_003: commonMessages.DOWNLOADED,
  B010080_001: "受注確定が完了しました。",
  B020010_001: "売上伝票番号 {0} を登録しました。",
  B020020_001: "売上データを削除しました。",
  B020040_001: commonMessages.PRINTING,
  B020040_002: commonMessages.DOWNLOADED,
  B020050_001: commonMessages.DOWNLOADED,
  B030010_001: "請求締処理を開始しました。",
  B030010_002: "請求締処理キャンセルが完了しました。",
  B030030_001: commonMessages.PRINTING,
  B030030_002: commonMessages.DOWNLOADED,
  B030050_001: "入金伝票番号 {0} を登録しました。",
  B030050_002: "入金データを削除しました。",
  B030050_003: "入金データを更新しました。",
  B030051_001: commonMessages.DOWNLOADED,
  B030060_001: commonMessages.DOWNLOADED,
  B030080_001: commonMessages.DOWNLOADED,
  B040010_001: "発注伝票番号 {0} を登録しました。",
  B040010_002: "発注データを更新しました。",
  B040010_003: "発注データの削除が完了しました。",
  B040020_001: "発注データの削除が完了しました。",
  B040020_002: commonMessages.DOWNLOADED,
  B040030_001: commonMessages.DOWNLOADED,
  B040040_001: "実行が完了しました。",
  B050010_001: "仕入伝票番号 {0} を登録しました。",
  B050010_002: "仕入データを更新しました。",
  B050010_003: "仕入データの削除が完了しました。",
  B050020_001: "仕入データの削除が完了しました。",
  B050030_001: commonMessages.DOWNLOADED,
  B060010_001: commonMessages.DOWNLOADED,
  B060020_001: commonMessages.PRINTING,
  B060020_002: commonMessages.DOWNLOADED,
  B060030_001: commonMessages.PRINTING,
  B060030_002: commonMessages.DOWNLOADED,
  B070010_001: commonMessages.DOWNLOADED,
  B080010_001: "出荷予定ファイル出力が完了しました。",
  B080020_001: commonMessages.PRINTING,
  B080020_002: commonMessages.DOWNLOADED,
  B080030_001: commonMessages.PRINTING,
  B080030_002: commonMessages.DOWNLOADED,
  B080040_001: commonMessages.PRINTING,
  B080040_002: commonMessages.DOWNLOADED,
  B080050_001: "出荷数の訂正が完了しました。",
  B080060_001: "出荷確定が完了しました。",
  B080070_001: commonMessages.DOWNLOADED,
  B080090_001: commonMessages.DOWNLOADED,
  B090010_001: commonMessages.DOWNLOADED,
  B090011_001: commonMessages.DOWNLOADED,
  B090020_001: "倉庫移動の登録が完了しました。",
  B090021_001: "倉庫移動の登録が完了しました。",
  B090030_001: "ロケーション移動の登録が完了しました。",
  B090040_001: "在庫調整の登録が完了しました。",
  B090050_001: commonMessages.DOWNLOADED,
  B090051_001: commonMessages.DOWNLOADED,
  B090060_001: "在庫データEXCELファイルの取り込みを行います。",
  B100040_001: "部門データを登録しました。",
  B100040_002: "部門データを更新しました。",
  B100050_001: "社員データを登録しました。",
  B100050_002: "社員データを更新しました。",
  B100060_001: "得意先データを登録しました。",
  B100060_002: "得意先データを更新しました。",
  B100063_001: commonMessages.DOWNLOADED,
  B100070_001: "得意先納入先データを登録しました。",
  B100070_002: "得意先納入先データを更新しました。",
  B100070_003: "得意先納入先データを削除しました。",
  B100073_001: commonMessages.DOWNLOADED,
  B100080_001: "仕入先データを登録しました。",
  B100080_002: "仕入先データを更新しました。",
  B100083_001: commonMessages.DOWNLOADED,
  B100100_001: "倉庫データを登録しました。",
  B100100_002: "倉庫データを更新しました。",
  B100110_001: "商品コード {0} で商品データを登録しました。",
  B100110_002: "商品コード {0} で商品データを更新しました。",
  B100113_001: commonMessages.DOWNLOADED,
  B100120_001: "商品分類データを登録しました。",
  B100120_002: "商品分類データを更新しました。",
  B100120_003: "商品分類データを削除しました。",
  B100130_001: "セット商品データを更新しました。",
  B100133_001: commonMessages.DOWNLOADED,
  B100140_001: "単価データを登録しました。",
  B100140_002: "単価データを更新しました。",
  B100140_003: "単価データを削除しました。",
  B100143_001: commonMessages.DOWNLOADED,
  B100150_001: "取引先別単価データを登録しました。",
  B100150_002: "取引先別単価データを更新しました。",
  B100150_003: "取引先別単価データを削除しました。",
  B100153_001: commonMessages.DOWNLOADED,
  B100180_001: "WH単価データを登録しました。",
  B100180_002: "WH単価データを更新しました。",
  B100180_003: "WH単価データを削除しました。",
  B100183_001: commonMessages.DOWNLOADED,
  B100190_001: "ロケーション管理データを登録しました。",
  B100190_002: "ロケーション管理データを更新しました。",
  B100190_003: "ロケーション管理データを削除しました。",
  B100193_001: commonMessages.DOWNLOADED,
  B100220_001: "配送ルート割付データを登録しました。",
  B100220_002: "配送ルート割付データを更新しました。",
  B100220_003: "配送ルート割付データを削除しました。",
  B100223_001: commonMessages.DOWNLOADED,
  B100230_001: "配送ルートバッチデータを登録しました。",
  B100230_002: "配送ルートバッチデータを更新しました。",
  B100230_003: "配送ルートバッチデータを削除しました。",
  B100900_001: "マスタデータEXCELファイルの取り込みを行います。",
  B100910_001: commonMessages.DOWNLOADED,
  B110010_001: "予約が完了しました。",
  B100020_001: commonMessages.DOWNLOADED,
  B110030_001: commonMessages.DOWNLOADED,
  B110040_001: "担当者別目標設定EXCELファイルの取り込みを行います。",
};

const commonErrors: MessageList = {
  NOT_EMPTY: "入力必須です。",
  NOT_FOUND: "該当データが存在しません。",
  INVALID_DATE: "正しい日付が入力されていません。",
  NOT_EXISTS_SYSTEM: "システム情報が存在しません。",
  NOT_EXISTS_SHOHIZEI: "消費税情報が存在しません。",
  NOT_EXISTS_GENKA: "原価情報が存在しません。",
  NOT_EXISTS_TOKUI: "得意先情報が存在しません。",
  NOT_EXISTS_SEIKYU: "請求先情報が存在しません。",
  NOT_EXISTS_NONYU: "納入先情報が存在しません。",
  NOT_EXISTS_BUMON: "部門情報が存在しません。",
  NOT_EXISTS_EIGYO: "営業情報が存在しません。",
  NOT_EXISTS_MEISHO: "名称情報が存在しません。",
  NOT_EXISTS_SHAIN: "社員情報が存在しません。",
  NOT_EXISTS_SOKO: "倉庫情報が存在しません。",
  NOT_EXISTS_SHOHIN: "商品情報が存在しません。",
  NOT_EXISTS_JUCHU: "受注情報が存在しません。",
  NOT_EXISTS_JUCHUMEI: "受注明細情報が存在しません。",
  NOT_EXISTS_SEIZOSHIJI: "製造指示情報が存在しません。",
  NOT_EXISTS_SHUKABATCH: "出荷バッチ情報が存在しません。",
  NOT_EXISTS_SHUKAYOTEI: "出荷予定情報が存在しません。",
  NOT_EXISTS_URIAGE: "売上情報が存在しません。",
  NOT_EXISTS_URIAGEMEI: "売上明細情報が存在しません。",
  NOT_EXISTS_JUCHUWORK: "受注ワーク情報が存在しません。",
  NOT_EXISTS_JUCHUMEIWORK: "受注明細ワーク情報が存在しません。",
  NOT_EXISTS_LOCATION: "ロケーション管理情報が存在しません。",
  NOT_EXISTS_ZAIKO: "在庫情報が存在しません。",
  NOT_EXISTS_HIKIATE: "引当情報が存在しません。",
  NOT_EXISTS_NYUKIN: "入金情報が存在しません。",
  NOT_EXISTS_NYUKINMEI: "入金明細情報が存在しません。",
  NOT_EXISTS_SEIKYUJOKEN: "請求条件情報が存在しません。",
  NOT_EXISTS_GINKO: "銀行情報が存在しません。",
  NOT_EXISTS_NYUKAYOTEI: "入荷予定情報が存在しません。",
  NOT_EXISTS_HACHU: "発注情報が存在しません。",
  NOT_EXISTS_HACHUMEI: "発注明細情報が存在しません。",
  NOT_EXISTS_SHIRE: "仕入情報が存在しません。",
  NOT_EXISTS_SHIREMEI: "仕入明細情報が存在しません。",
  NOT_EXISTS_TANKA: "単価情報が存在しません。",
  NOT_EXISTS_UCHIWAKE: "内訳区分情報が存在しません。",
  NOT_EXISTS_KENGENTEIGI: "利用権限定義情報が存在しません。",
  NOT_EXISTS_NYUSHUTSURYOKU: "入出力制御情報が存在しません。",
  NOT_EXISTS_HAISOROUTEASS: "配送ルート割付情報が存在しません。",
  NOT_EXISTS_HAISOROUTEBATCH: "配送ルートバッチ情報が存在しません。",
  NOT_EXISTS_BATCH: "バッチ情報が存在しません。",
  NOT_EXISTS_ZONE: "ゾーン管理情報が存在しません。",
  NOT_EXISTS_DAIBUNRUI: "商品大分類情報が存在しません。",
  NOT_EXISTS_CHUBUNRUI: "商品中分類情報が存在しません。",
  NOT_EXISTS_SHOBUNRUI: "商品小分類情報が存在しません。",
  NOT_EXISTS_CHOHYO: "帳票設定情報が取得できません。",
  CANNOT_OUTPUT: "帳票が出力できません。",
  EXCEEDED_OUTPUT_LIMIT: "出力件数が上限値 {0} 件を超えています。",
  EXCEEDED_INPUT_LIMIT: "取込件数が上限値 {0} 件を超えています。",
  JuHachuNo: "受注No.{0}-{1} 発注No.{2}-{3}",
};

const serverErrors: MessageList = {
  S000000_001: "{0} " + commonErrors.NOT_EMPTY,
  S000000_002: "{0} " + commonErrors.NOT_EMPTY,
  S000000_003: "{0} 日付の書式が不正です。",
  S000000_004: "{0} " + commonErrors.NOT_EXISTS_TOKUI,
  S000000_005: "{0} " + commonErrors.NOT_EXISTS_BUMON,
  S000000_006: "{0} " + commonErrors.NOT_EXISTS_EIGYO,
  S000000_007: "{0} " + commonErrors.NOT_EXISTS_MEISHO,
  S000000_008: "{0} " + commonErrors.NOT_EXISTS_SHAIN,
  S000000_009: "{0} " + commonErrors.NOT_EXISTS_SOKO,
  S000000_010: "{0} " + commonErrors.NOT_EXISTS_SHOHIN,
  S000000_011: "{0} 区分が不正です。",
  S000000_012: "{0} " + commonErrors.NOT_EXISTS_JUCHU,
  S000000_013: "{0} " + commonErrors.NOT_EXISTS_SHUKAYOTEI,
  S000000_014: "{0} " + commonErrors.NOT_EXISTS_URIAGE,
  S000000_015: "{0} " + commonErrors.NOT_EXISTS_JUCHUWORK,
  S000000_016: "{0} " + commonErrors.NOT_EXISTS_LOCATION,
  S000000_017: "{0} " + commonErrors.NOT_EXISTS_NONYU,
  S000000_018: "{0} " + commonErrors.NOT_EXISTS_NYUKIN,
  S000000_019: "{0} 時刻が不正です。",
  S000000_020: "{0} " + commonErrors.NOT_EXISTS_SHOHIN,
  S000000_021: "{0} " + commonErrors.NOT_EXISTS_SHIRE,
  S000000_022: "{0} " + commonErrors.NOT_EXISTS_HACHU,
  S000000_023: "{0} " + commonErrors.NOT_EXISTS_HAISOROUTEASS,
  S000000_024: "{0} " + commonErrors.NOT_EXISTS_HAISOROUTEBATCH,
  S000000_025: "{0} " + commonErrors.NOT_EXISTS_BATCH,
  S000000_026: "{0} " + commonErrors.NOT_EXISTS_SEIKYU,
  S000100_001:
    "他のユーザが更新した可能性があります、最新の情報を確認してください。",
  S000100_002: "データベースに接続できません。管理者に連絡してください。",
  S000100_003:
    "データベース検索時に想定外のエラーが発生しました。管理者に連絡して下さい。",
  S000100_004:
    "処理を正常に行うことができませんでした、管理者に連絡してください。",
  S000100_005: "帳票設定情報が取得できません。管理者に連絡して下さい。",
  S000100_006:
    "帳票設定が印刷でもダウンロードでもありません。管理者に連絡して下さい。",
  S000200_001: "不明なエラーです。管理者に連絡して下さい。",
  S000200_002:
    "サーバーへの接続がタイムアウトしました。ネットワークの接続状況を確認してください。",
  B000010_001: "不正なリクエストのため、ログインできません。",
  B000010_002: "ログインIDが入力されていません。",
  B000010_003: "存在しないログインIDです。",
  B000010_004: "退社済みのためログインできません。",
  B000010_005: "削除済みのためログインできません。",
  B000010_006: "パスワードが一致しません。",
  B000011_001: "認証キーが保存されていません。端末認証を行ってください。",
  B000011_002: "開始日が保存されていません。端末認証を行ってください。",
  B000011_003: "認証キーが未登録です。端末認証を行ってください。",
  B000011_004:
    "入力した認証キーは利用できません。利用可能な認証キーを入力してください。",
  B000030_001: commonErrors.NOT_EXISTS_JUCHUMEI,
  B000030_002: "セット品ではないため検索できません。",
  B000111_001: commonErrors.NOT_FOUND,
  B000111_002: "伝票種別との組み合わせが不正なため使用できません。",
  B000120_001: commonErrors.NOT_FOUND,
  B000130_001: commonErrors.NOT_FOUND,
  B000140_001: commonErrors.NOT_FOUND,
  B000150_001: commonErrors.NOT_FOUND,
  B000151_001: commonErrors.NOT_FOUND,
  B000160_001: "完了区分には1か2を設定してください。",
  B000160_002: commonErrors.NOT_EXISTS_KENGENTEIGI,
  B000160_003: "営業所コード(From)の値が不正です。",
  B000160_004: "営業所コード(To)の値が不正です。",
  B000160_005: "Excel出力に失敗しました。",
  B000160_006: "商品中分類指定時は大分類も入力して下さい。",
  B000160_007: "商品小分類指定時は大分類も入力して下さい。",
  B000160_008: "商品小分類指定時は中分類も入力して下さい。",
  B000160_009: "権限IDが取得できませんでした。",
  B000160_010: "検索条件に一致するデータは存在しません。",
  B000170_001: commonErrors.NOT_FOUND,
  B000180_001: commonErrors.NOT_FOUND,
  B000190_001: commonErrors.NOT_FOUND,
  B000190_002: "指定された倉庫はこの画面では使用できません。",
  B000200_001: commonErrors.NOT_FOUND,
  B000200_002: commonErrors.NOT_FOUND,
  B000202_001: "入力された商品分類は存在しません。再度入力して下さい。",
  B000202_002: commonErrors.NOT_FOUND,
  B000202_003: commonErrors.NOT_FOUND,
  B000202_004: commonErrors.NOT_FOUND,
  B000220_001: "商品中分類指定時は大分類も入力して下さい。",
  B000220_002: "商品小分類指定時は中分類も入力して下さい。",
  B000220_003: commonErrors.NOT_EXISTS_SOKO,
  B000220_004: "倉庫種別には1,2,3,4,5のいずれかの値を設定してください。",
  B000223_001: commonErrors.NOT_FOUND,
  B000224_001: commonErrors.NOT_FOUND,
  B000230_001: commonErrors.NOT_FOUND,
  B010010_001: "受注明細が入力されていません。",
  B010010_002: "明細{0}行目 見込生産品でない商品が存在します。",
  B010010_003: "見込生産品のため、製作日が必要です。",
  B010010_004: "明細に受注生産品を含むため、製作日が必要です。",
  B010010_005: "明細{0}行目 セット品でセット構成が入力されていません。",
  B010010_006:
    "明細{0}行目の明細構成{1}行目 見込生産品のセット品に見込生産品でない商品が存在します。",
  B010010_007: "セット品に受注生産品を含むため、製作日が必要です。",
  B010010_008: "受注日 ≦ 製作日 ≦ 発送日で指定してください。",
  B010010_009: "受注日 ≦ 発送日で指定してください。",
  B010010_010: "発送日 ≦ 必着日で指定してください。",
  B010010_011: "発送日 ≦ 持参日で指定してください。",
  B010010_012: commonErrors.NOT_EXISTS_TOKUI,
  B010010_013: commonErrors.NOT_EXISTS_SYSTEM,
  B010010_014: commonErrors.NOT_EXISTS_SHOHIZEI,
  B010010_015: "明細{0}行目 " + commonErrors.NOT_EXISTS_SHOHIN,
  B010010_017: "明細{0}行目 当該商品は物流倉庫に存在しません。",
  B010010_018: "明細{0}行目 " + commonErrors.NOT_EXISTS_HIKIATE,
  B010010_019: "明細{0}行目 在庫がありません。",
  B010010_020: "明細{0}行目 " + commonErrors.NOT_EXISTS_SHOHIN,
  B010010_023: "既存データの明細{0}行目 " + commonErrors.NOT_EXISTS_HIKIATE,
  B010010_024: "当該受注が存在しないため、更新できません。",
  B010010_025: "物流倉庫でないため、引当可能数を取得できません。",
  B010010_026: commonErrors.NOT_EXISTS_SHOHIN,
  B010010_027:
    "システムマスタからデータを取得できないため、引当可能数を取得できません。",
  B010010_028: "明細{0}行目 受注生産品で外寸Wが入力されていません。",
  B010010_029: "受注生産品で外寸Hが入力されていません。",
  B010010_030: "受注生産品の材料商品が取得できません。",
  B010010_031: "在庫数が取得できないため、引当可能数を取得できません。",
  B010010_032: "引当情報が存在しないため、引当可能数を取得できません。",
  B010010_033: "WH単価マスタを取得できません。",
  B010010_034: "明細{0}行目 内訳情報を取得できません。",
  B010010_035:
    "明細{0}行目 " +
    "受注生産品で外寸Wが入力されていないため、引当できません。",
  B010010_036:
    "明細{0}行目 " +
    "受注生産品で外寸Hが入力されていないため、引当できません。",
  B010010_037: commonErrors.NOT_EXISTS_MEISHO,
  B010010_038: commonErrors.NOT_EXISTS_MEISHO,
  B010010_039: "伝票種別コードと添付伝票コードの組み合わせが不正です。",
  B010010_040: "明細{0}行目 受注数には1以上の値を入力してください。",
  B010010_041: "明細{0}行目 掛率には0~999の値を入力してください。",
  B010010_042: "明細{0}行目 材料品の商品は入力できません。",
  B010010_043: "明細{0}行目 外寸に片方の数値だけ入力されています。",
  B010010_044: "明細{0}行目 外寸には1以上の値を入力してください。",
  B010010_045: "明細{0}行目 内寸に片方の数値だけ入力されています。",
  B010010_047: "明細{0}行目 WH単価の商品に外寸が入力されていません。",
  B010010_048:
    "明細{0}行目の明細構成{1}行目 受注数には1以上の値を入力してください。",
  B010010_049:
    "明細{0}行目の明細構成{1}行目 掛率には0~999の値を入力してください。",
  B010010_050: "明細{0}行目の明細構成{1}行目 材料品の商品は入力できません。",
  B010010_051:
    "明細{0}行目の明細構成{1}行目 外寸に片方の数値だけ入力されています。",
  B010010_052:
    "明細{0}行目の明細構成{1}行目 外寸には1以上の値を入力してください。",
  B010010_053:
    "明細{0}行目の明細構成{1}行目 内寸に片方の数値だけ入力されています。",
  B010010_055:
    "明細{0}行目の明細構成{1}行目 WH単価の商品に外寸が入力されていません。",
  B010010_056: "客先Noに半角英数字以外が入力されています。",
  B010010_057:
    "明細{0}行目の明細構成{1}行目 当該商品は物流倉庫に存在しません。",
  B010010_058:
    "明細{0}行目の明細構成{1}行目 " + commonErrors.NOT_EXISTS_HIKIATE,
  B010010_059: "明細{0}行目の明細構成{1}行目 在庫がありません。",
  B010010_060: "明細{0}行目の明細構成{1}行目 " + commonErrors.NOT_EXISTS_SHOHIN,
  B010010_061:
    "明細{0}行目の明細構成{1}行目 " +
    "受注生産品で外寸Wが入力されていないため、引当できません。",
  B010010_062:
    "明細{0}行目の明細構成{1}行目 " +
    "受注生産品で外寸Hが入力されていないため、引当できません。",
  B010010_063:
    "明細{0}行目の明細構成{1}行目 " + commonErrors.NOT_EXISTS_HIKIATE,
  B010010_064: "明細{0}行目の明細構成{1}行目 WH単価マスタを取得できません。",
  B010010_065: "明細{0}行目 WH単価マスタを取得できません。",
  B010010_066: commonErrors.NOT_EXISTS_NONYU,
  B010010_067: "取引終了日を過ぎている得意先が入力されています。",
  B010010_068: "取引終了日を過ぎている納入先が入力されています。",
  B010010_069: "得意先名 入力必須です。",
  B010010_070: "納入先名 入力必須です。",
  B010010_071: "得意先・納入先の組み合わせが正しくありません。",
  B010010_072: "発送日 ≦ 伝票日付で指定してください。",
  B010010_073:
    "すでに受注ステータスが「受注確定済み」以降のため更新できません。",
  B010020_001: commonErrors.NOT_EXISTS_JUCHU,
  B010020_002: commonErrors.NOT_EXISTS_JUCHUMEI,
  B010020_003: commonErrors.NOT_EXISTS_SHOHIZEI,
  B010020_004: commonErrors.NOT_EXISTS_JUCHU,
  B010020_005: commonErrors.NOT_EXISTS_JUCHUMEI,
  B010020_006: commonErrors.NOT_EXISTS_SHOHIZEI,
  B010020_010:
    "キャンセル済みの受注情報が含まれているため、キャンセルできません。",
  B010020_011:
    "出荷確定済みの受注情報が含まれているため、キャンセルできません。",
  B010020_012: commonErrors.NOT_EXISTS_URIAGE,
  B010020_013: commonErrors.NOT_EXISTS_SHUKABATCH,
  B010020_014: commonErrors.NOT_EXISTS_ZAIKO,
  B010020_015: "商品小分類指定時は大分類と中分類も入力して下さい。",
  B010020_016: "商品中分類指定時は大分類も入力して下さい。",
  B010030_001: "商品中分類指定時は大分類も入力して下さい。",
  B010030_002: "商品小分類指定時は大分類と中分類も入力して下さい。",
  B010040_001: commonErrors.NOT_FOUND,
  B010040_002: commonErrors.CANNOT_OUTPUT,
  B010040_003: "商品小分類指定時は大分類と中分類も入力して下さい。",
  B010040_004: "商品中分類指定時は大分類も入力して下さい。",
  B010040_005: commonErrors.NOT_EXISTS_NYUSHUTSURYOKU,
  B010040_006: commonErrors.EXCEEDED_OUTPUT_LIMIT,
  B010050_001: commonErrors.NOT_EXISTS_SHOHIZEI,
  B010050_002: commonErrors.NOT_EXISTS_SYSTEM,
  B010050_003: commonErrors.NOT_EXISTS_TOKUI,
  B010050_004: commonErrors.NOT_EXISTS_SHOHIN,
  B010050_005: commonErrors.NOT_EXISTS_GENKA,
  B010050_006: commonErrors.NOT_EXISTS_SHAIN,
  B010050_007: commonErrors.NOT_EXISTS_NONYU,
  B010060_001: "受注ワーク明細が入力されていません。",
  B010060_002: "製作日が入力されていません。",
  B010060_004: "セット品でセット構成が入力されていません。",
  B010060_005: "明細に受注生産品を含むため、製作日が必要です。",
  B010060_007: "受注に反映済みの受注ワーク情報は更新できません。",
  B010060_008: "受注に反映済み(一部在庫不足)の受注ワーク情報は更新できません。",
  B010060_009: "受注日 ≦ 製作日で指定してください。",
  B010060_010: "製作日 ≦ 発送日で指定してください。",
  B010060_011: "発送日 ≦ 受注日で指定してください。",
  B010060_012: "発送日 ≦ 必着日で指定してください。",
  B010060_013: "発送日 ≦ 持参日で指定してください。",
  B010060_014: commonErrors.NOT_EXISTS_TOKUI,
  B010060_015: commonErrors.NOT_EXISTS_SYSTEM,
  B010060_016: commonErrors.NOT_EXISTS_SHOHIZEI,
  B010060_017: commonErrors.NOT_EXISTS_SHOHIN,
  B010060_018: commonErrors.NOT_EXISTS_GENKA,
  B010060_019: "内訳情報を取得できません。",
  B010060_020: commonErrors.NOT_EXISTS_JUCHUWORK,
  B010060_021: "明細の受注数には1以上の値を入力してください。",
  B010060_022: "明細の掛率には0~999の値を入力してください。",
  B010060_023: "明細に材料品の商品は入力できません。",
  B010060_024: "明細の外寸に片方の数値だけ入力されています。",
  B010060_025: "明細の外寸には1以上の値を入力してください。",
  B010060_026: "明細の内寸に片方の数値だけ入力されています。",
  B010060_028: "明細のWH単価の商品に外寸が入力されていません。",
  B010060_029: "明細構成の受注数には1以上の値を入力してください。",
  B010060_030: "明細構成の掛率には0~999の値を入力してください。",
  B010060_031: "明細構成に材料品の商品は入力できません。",
  B010060_032: "明細構成の外寸に片方の数値だけ入力されています。",
  B010060_033: "明細構成の外寸には1以上の値を入力してください。",
  B010060_034: "明細構成の内寸に片方の数値だけ入力されています。",
  B010060_036: "明細構成のWH単価の商品に外寸が入力されていません。",
  B010060_037: commonErrors.NOT_EXISTS_MEISHO,
  B010060_038: commonErrors.NOT_EXISTS_MEISHO,
  B010060_039: "伝票種別コードと添付伝票コードの組み合わせが不正です。",
  B010060_040: commonErrors.NOT_EXISTS_NONYU,
  B010060_041: "取引終了日を過ぎている得意先が入力されています。",
  B010060_042: "取引終了日を過ぎている納入先が入力されています。",
  B010060_043: "得意先名 入力必須です。",
  B010060_044: "納入先名 入力必須です。",
  B010060_045: "得意先・納入先の組み合わせが正しくありません。",
  B010070_001: commonErrors.NOT_FOUND,
  B010070_002: commonErrors.CANNOT_OUTPUT,
  B010070_003: commonErrors.NOT_EXISTS_JUCHUWORK,
  B010070_004: "反映済みの受注ワーク情報が含まれるため、削除できません。",
  B010070_005: commonErrors.NOT_EXISTS_JUCHUWORK,
  B010070_006:
    "反映済みでない受注ワーク情報が含まれるため、エクセルを出力できません。",
  B010070_007: commonErrors.NOT_EXISTS_JUCHUWORK,
  B010070_008: commonErrors.NOT_EXISTS_JUCHUMEIWORK,
  B010070_009: commonErrors.NOT_EXISTS_SHOHIZEI,
  B010070_010: commonErrors.NOT_EXISTS_NYUSHUTSURYOKU,
  B010070_011: commonErrors.EXCEEDED_OUTPUT_LIMIT,
  B010070_012: commonErrors.NOT_EXISTS_JUCHUWORK,
  B010070_013: commonErrors.NOT_EXISTS_TOKUI,
  B010070_014: commonErrors.NOT_EXISTS_SYSTEM,
  B010070_015: commonErrors.NOT_EXISTS_SHOHIZEI,
  B010080_001: "キャンセル済みの受注情報が含まれるため、受注確定できません。",
  B010080_002: "受注登録済み以外の受注情報が含まれるため、受注確定できません。",
  B010080_003: commonErrors.NOT_EXISTS_SHOHIN,
  B010080_004: commonErrors.NOT_EXISTS_SOKO,
  B010080_005: commonErrors.NOT_EXISTS_ZAIKO,
  B010080_006: commonErrors.NOT_EXISTS_LOCATION,
  B010080_007: commonErrors.NOT_EXISTS_TOKUI,
  B010080_008: "得意先情報の伝票行数が設定されていません。",
  B010080_009: commonErrors.NOT_EXISTS_JUCHU,
  B010080_010: "商品小分類指定時は大分類と中分類も入力して下さい。",
  B010080_011: "商品中分類指定時は大分類も入力して下さい。",
  B010080_012: "得意先支店コード指定時は得意先コードも入力して下さい。",
  B010080_013: "納入先支店コード指定時は納入先コードも入力して下さい。",
  B020010_001: "セット品でセット構成が入力されていません。",
  B020010_002: "受注生産品以外の商品で倉庫コードが入力されていません。",
  B020010_003: commonErrors.NOT_EXISTS_SOKO,
  B020010_004: "返品倉庫以外の倉庫が入力されています。",
  B020010_005: "その他倉庫以外の倉庫が入力されています。",
  B020010_006: "物流倉庫以外の倉庫が入力されています。",
  B020010_007: commonErrors.NOT_EXISTS_SHOHIN,
  B020010_008: commonErrors.NOT_EXISTS_GENKA,
  B020010_009: commonErrors.NOT_EXISTS_SHOHIN,
  B020010_010: commonErrors.NOT_EXISTS_GENKA,
  B020010_011: commonErrors.NOT_EXISTS_URIAGE,
  B020010_012: "売上伝票発行区分の値が不正なため処理を行えません。",
  B020010_013: "内訳区分の値が不正なため処理を行えません。",
  B020010_014: "ロケーション情報を取得できません。",
  B020010_015: commonErrors.NOT_EXISTS_ZAIKO,
  B020010_016: "内訳区分の値が不正なため処理を行えません。",
  B020010_017: commonErrors.NOT_EXISTS_TOKUI,
  B020010_018: commonErrors.NOT_EXISTS_SYSTEM,
  B020010_019: commonErrors.NOT_EXISTS_SHOHIZEI,
  B020010_020: "内訳情報を取得できません。",
  B020010_021: commonErrors.NOT_EXISTS_URIAGE,
  B020010_022: commonErrors.NOT_EXISTS_URIAGEMEI,
  B020010_023: commonErrors.NOT_EXISTS_TOKUI,
  B020010_024: commonErrors.NOT_EXISTS_SOKO,
  B020010_025: commonErrors.NOT_EXISTS_MEISHO,
  B020010_026: commonErrors.NOT_EXISTS_MEISHO,
  B020010_027: "伝票種別コードと添付伝票コードの組み合わせが不正です。",
  B020010_028: "返品の場合、取引数は0より大きい値を設定してください。",
  B020010_029: "客先注文Noに不正な値が入力されています。",
  B020010_030: commonErrors.NOT_EXISTS_SHAIN,
  B020010_031: "受注情報を取得できません。",
  B020010_032: "返品倉庫とその他倉庫以外の倉庫が入力されています。",
  B020010_033: "専用伝票Noに半角英数字以外が入力されています。",
  B020010_034: "客先Noに半角英数字以外が入力されています。",
  B020010_035: commonErrors.NOT_EXISTS_NONYU,
  B020010_036: "取引終了日を過ぎている得意先が入力されています。",
  B020010_037: "取引終了日を過ぎている納入先が入力されています。",
  B020010_038: "得意先名 入力必須です。",
  B020010_039: "納入先名 入力必須です。",
  B020010_040: "得意先・納入先の組み合わせが正しくありません。",
  B020020_001: commonErrors.NOT_FOUND,
  B020020_002: commonErrors.NOT_EXISTS_URIAGEMEI,
  B020020_003: commonErrors.NOT_EXISTS_SHOHIZEI,
  B020020_004: "複製区分: {0} が不正なため複製できません。",
  B020020_005: commonErrors.NOT_EXISTS_TOKUI,
  B020020_006: commonErrors.NOT_EXISTS_URIAGE,
  B020020_007: "対象データの内訳区分が売上対象ではない場合",
  B020020_008: "営業コードがAPJ,APJ工房以外の場合",
  B020020_009: "商品小分類指定時は大分類と中分類も入力して下さい。",
  B020020_010: "商品中分類指定時は大分類も入力して下さい。",
  B020020_011: "得意先支店コード指定時は得意先コードも入力して下さい。",
  B020030_001: "消化区分の値が不正なため処理を行えません。",
  B020030_002: "営業所コードの値が不正なため処理を行えません。",
  B020030_003: "商品小分類指定時は大分類と中分類も入力して下さい。",
  B020030_004: "商品中分類指定時は大分類も入力して下さい。",
  B020030_005: "得意先支店コード指定時は得意先コードも入力して下さい。",
  B020040_001: "EXCEL出力するデータが存在しません。",
  B020040_002: "EXCEL作成時にエラーが発生しました。",
  B020040_003: "更新時に売上ファイルが取得できませんでした。",
  B020040_004: "売上明細ファイルが取得できませんでした。",
  B020040_005: "売上伝票番号に対して売上明細ファイルの数が不正です。",
  B020040_006:
    "伝票種別コードと添付伝票コードに合致するテンプレートが取得できませんでした。",
  B020040_007: commonErrors.NOT_EXISTS_NYUSHUTSURYOKU,
  B020040_008: commonErrors.EXCEEDED_OUTPUT_LIMIT,
  B020050_001:
    "出力順１に得意先、売上担当者、売上日、売上No以外が選択されています。",
  B020050_002:
    "出力順２に得意先、売上担当者、売上日、売上No以外が選択されています。",
  B020050_003:
    "出力順３に得意先、売上担当者、売上日、売上No以外が選択されています。",
  B020050_004: commonErrors.NOT_FOUND,
  B020050_005: commonErrors.EXCEEDED_OUTPUT_LIMIT,
  B020050_006: commonErrors.CANNOT_OUTPUT,
  B020050_008: "商品小分類指定時は大分類と中分類も入力して下さい。",
  B020050_009: "商品中分類指定時は大分類も入力して下さい。",
  B020050_010: commonErrors.NOT_EXISTS_NYUSHUTSURYOKU,
  B030010_001: commonErrors.NOT_EXISTS_SYSTEM,
  B030010_002: "請求締処理を実行中です。",
  B030010_003: "請求締処理を予約中です。",
  B030010_004: "対象請求先件数が0以下となっています。",
  B030010_005: commonErrors.NOT_EXISTS_SEIKYUJOKEN,
  B030010_006: "請求締日と当月が同じではありません。",
  B030010_007: "請求締日 ≦ 請求日で指定してください。",
  B030010_008: "請求締日 ≦ 入金対象日で指定してください。",
  B030010_009: commonErrors.NOT_EXISTS_SEIKYUJOKEN,
  B030010_010: "請求締状況ステータスが処理中ではありません。",
  B030010_011: commonErrors.NOT_EXISTS_SYSTEM,
  B030010_012: "請求締処理実行区分が未実行ではありません。",
  B030010_013: "締処理キャンセルが出来ないステータスです。",
  B030010_014: "請求先が設定されていません。",
  B030020_001: "請求条件ファイルが取得できませんでした。",
  B030020_002: "処理状況が処理中のため遷移できません。",
  B030020_003: "対象データのステータスが不正です。",
  B030020_004: "対象データのステータスが不正です。",
  B030020_005: "対象データのステータスが不正です。",
  B030020_006: "処理状況が処理中のため遷移できません。",
  B030030_001: "請求書タイプには1か2を設定してください。",
  B030030_002: "出力形式には1か2を設定してください。",
  B030030_003: "印刷に失敗しました。",
  B030030_004: "pdf出力に失敗しました。",
  B030030_005: "検索結果が0件です。",
  B030030_006: "検索結果に請求書未発行のデータが含まれています。",
  B030030_007: "Zip化処理に失敗しました。",
  B030030_008: "ファイルの複製に失敗しました。",
  B030030_009: "ディレクトリの作成に失敗しました。",
  B030030_010: "請求書が取得できませんでした。",
  B030030_011: "HttpServletResponseの設定に失敗しました。",
  B030030_012:
    "請求書が作成されていません。請求締処理を行ってから再度実行してください。",
  B030030_013:
    "請求書が作成されていません。請求締処理を行ってから再度実行してください。",
  B030030_014:
    "請求書が作成されていません。請求締処理を行ってから再度実行してください。",
  B030030_015: "同一売上伝票番号のデータの件数が 10 件より多い場合",
  B030030_016: commonErrors.NOT_EXISTS_SEIKYUJOKEN,
  B030030_017: "検索結果に請求明細書出力可能なデータが存在しません。",
  B030030_018: commonErrors.NOT_EXISTS_NYUSHUTSURYOKU,
  B030030_019: commonErrors.EXCEEDED_OUTPUT_LIMIT,
  B030040_001: commonErrors.NOT_FOUND,
  B030040_002: commonErrors.NOT_FOUND,
  B030050_001: commonErrors.NOT_EXISTS_NYUKINMEI,
  B030050_002: commonErrors.NOT_EXISTS_NYUKIN,
  B030050_003: commonErrors.NOT_EXISTS_GINKO,
  B030050_004: "内訳コードが不正です。",
  B030050_005: "変更対象データに締処理済みのデータが含まれています。",
  B030050_006: "内訳区分が手形、電手形以外のため手形番号が必要です。",
  B030050_007: "内訳区分が手形、電手形以外のため手形種別が必要です。",
  B030050_008: "内訳区分が手形、電手形以外のため手形振出日が必要です。",
  B030050_009: "内訳区分が手形、電手形以外のため手形決済日が必要です。",
  B030051_001: commonErrors.EXCEEDED_OUTPUT_LIMIT,
  B030051_002: "Excel出力に失敗しました。",
  B030051_003: commonErrors.NOT_EXISTS_NYUSHUTSURYOKU,
  B030060_001: "売掛データがありません。",
  B030060_002: commonErrors.CANNOT_OUTPUT,
  B030060_003: commonErrors.NOT_EXISTS_NYUSHUTSURYOKU,
  B030060_004: commonErrors.EXCEEDED_OUTPUT_LIMIT,
  B030060_005: commonErrors.NOT_EXISTS_SHOHIZEI,
  B030070_001: "取引区分には0、1、2のいずれかの値を設定してください。",
  B030070_002: "検索結果が0件です。",
  B030080_001: "売掛先条件には9、0、1のいずれかの値を設定してください。",
  B030080_002: "出力方法には0、1のいずれかの値を設定してください。",
  B030080_003: "得意先元帳情報が存在しません。",
  B030080_004: commonErrors.CANNOT_OUTPUT,
  B030080_005: commonErrors.NOT_EXISTS_NYUSHUTSURYOKU,
  B030080_006: commonErrors.EXCEEDED_OUTPUT_LIMIT,
  B040010_001: "希望納期に発注日より前の日付が設定されています。",
  B040010_002: "明細データの希望納期に発注日より前の日付が設定されています。",
  B040010_003: "入荷された発注明細データが変更されています。",
  B040010_004:
    "入荷された発注明細データを含む場合、ヘッダーデータは変更できません。",
  B040010_005: "発注情報が存在しません。",
  B040010_006: "仕入情報が存在しません。",
  B040010_007: commonErrors.NOT_EXISTS_SHAIN,
  B040010_008: commonErrors.NOT_EXISTS_SOKO,
  B040010_009: "内訳区分情報が存在しません。",
  B040010_012:
    "内訳区分が通常または見本で、発注数が設定されていない明細データが含まれています。",
  B040010_013:
    "内訳区分が通常または見本で、発注単価が設定されていない明細データが含まれています。",
  B040010_014:
    "内訳区分が値引で、発注数が設定されている明細データが含まれています。",
  B040010_015:
    "内訳区分が値引で、発注単価が設定されている明細データが含まれています。",
  B040010_016: commonErrors.NOT_EXISTS_SHOHIN,
  B040010_017: commonErrors.NOT_EXISTS_SOKO,
  B040010_018: "ロケーション管理情報が存在しません。",
  B040010_019: "在庫情報の取得件数が0件です。",
  B040010_020: "入荷された発注明細データを含むため削除できません。",
  B040010_021: "発注情報が存在しません。",
  B040010_022: "発注明細情報が存在しません。",
  B040010_023: "社員関連情報が存在しません。",
  B040010_024: "商品関連情報が存在しません。",
  B040010_025:
    "入荷された発注明細データを含むため、明細の削除・追加はできません。",
  B040020_001: "完了区分には1か2を設定してください。",
  B040020_002: "発注明細情報を取得できません。",
  B040020_003: "営業所コードの値が不正なため処理を行えません。",
  B040020_004: commonErrors.NOT_EXISTS_SOKO,
  B040020_005: "Excel出力に失敗しました。",
  B040020_006: "権限IDが取得できませんでした。",
  B040020_007: commonErrors.NOT_EXISTS_KENGENTEIGI,
  B040020_008: "営業所コード(From)の値が不正です。",
  B040020_009: "営業所コード(To)の値が不正です。",
  B040020_010: "検索条件に一致するデータは存在しません。",
  B040020_011: commonErrors.NOT_EXISTS_NYUSHUTSURYOKU,
  B040020_012: commonErrors.EXCEEDED_OUTPUT_LIMIT,
  B040020_013: commonErrors.NOT_EXISTS_TANKA,
  B040030_001: "完了区分には1か2を設定してください。",
  B040030_002: commonErrors.NOT_EXISTS_KENGENTEIGI,
  B040030_003: "営業所コード(From)の値が不正です。",
  B040030_004: "営業所コード(To)の値が不正です。",
  B040030_005: "Excel出力に失敗しました。",
  B040030_006: "商品中分類指定時は大分類も入力して下さい。",
  B040030_007: "商品小分類指定時は大分類も入力して下さい。",
  B040030_008: "商品小分類指定時は中分類も入力して下さい。",
  B040030_009: "権限IDが取得できませんでした。",
  B040030_010: "検索条件に一致するデータは存在しません。",
  B040030_011: commonErrors.NOT_EXISTS_NYUSHUTSURYOKU,
  B040030_012: commonErrors.EXCEEDED_OUTPUT_LIMIT,
  B040040_001: "完了区分には1か2を設定してください。",
  B040040_002: commonErrors.NOT_EXISTS_KENGENTEIGI,
  B040040_003: "営業所コード(From)の値が不正です。",
  B040040_004: "営業所コード(To)の値が不正です。",
  B040040_005: commonErrors.NOT_EXISTS_HACHU,
  B040040_006: "商品中分類指定時は大分類も入力して下さい。",
  B040040_007: "商品小分類指定時は大分類も入力して下さい。",
  B040040_008: "商品小分類指定時は中分類も入力して下さい。",
  B040040_009: "権限IDが取得できませんでした。",
  B040040_010: "検索条件に一致するデータは存在しません。",
  B040040_011: commonErrors.NOT_EXISTS_HACHUMEI,
  B040040_012: commonErrors.NOT_EXISTS_NYUKAYOTEI,
  B040040_013: "1つの発注明細情報に対して、入荷予定情報が複数存在します。",
  B050010_006: "{0} " + commonErrors.NOT_EXISTS_SOKO,
  B050010_007: "{0} " + commonErrors.NOT_EXISTS_UCHIWAKE,
  B050010_008:
    "{0} 内訳区分が通常または見本で、仕入数が設定されていない明細データが含まれています。",
  B050010_009:
    "{0} 内訳区分が通常または見本で、仕入単価が設定されていない明細データが含まれています。",
  B050010_010:
    "{0} 内訳区分が値引で、仕入数が設定されている明細データが含まれています。",
  B050010_011:
    "{0} 内訳区分が値引で、仕入単価が設定されている明細データが含まれています。",
  B050010_013: "{0} 在庫が不足しています。",
  B050010_014: "{0} " + commonErrors.NOT_EXISTS_SHIRE,
  B050010_015: "{0} " + commonErrors.NOT_EXISTS_SHOHIN,
  B050010_016: "{0} " + commonErrors.NOT_EXISTS_SOKO,
  B050010_017: "{0} " + commonErrors.NOT_EXISTS_SHOHIN,
  B050010_018: commonErrors.NOT_EXISTS_SHIRE,
  B050010_019: commonErrors.NOT_EXISTS_TANKA,
  B050010_020: commonErrors.NOT_EXISTS_SHOHIZEI,
  B050010_021: commonErrors.NOT_EXISTS_SHAIN,
  B050010_022: "{0} " + commonErrors.NOT_EXISTS_SHOHIN,
  B050010_023: "{0} " + commonErrors.NOT_EXISTS_SOKO,
  B050010_024: "月次更新後のデータは削除できません。",
  B050010_025: "入荷・入庫一括確定で作成されたデータは削除できません。",
  B050011_001: commonErrors.NOT_EXISTS_HACHU,
  B050011_002: "{0} が発注データと異なります。",
  B050011_003: "{0} " + commonErrors.NOT_EXISTS_HACHUMEI,
  B050011_004: "{0} {1} 発注明細データと異なります。",
  B050011_005: "{0} 発注行番号が設定されています。",
  B050011_006: "{0} " + commonErrors.NOT_EXISTS_SOKO,
  B050011_007: "{0} " + commonErrors.NOT_EXISTS_UCHIWAKE,
  B050011_008:
    "{0} 内訳区分が通常または見本で、仕入数が設定されていない明細データが含まれています。",
  B050011_009:
    "{0} 内訳区分が通常または見本で、仕入単価が設定されていない明細データが含まれています。",
  B050011_010:
    "{0} 内訳区分が値引で、仕入数が設定されている明細データが含まれています。",
  B050011_011:
    "{0} 内訳区分が値引で、仕入単価が設定されている明細データが含まれています。",
  B050011_012: "{0} " + commonErrors.NOT_EXISTS_LOCATION,
  B050011_013: "{0} 仕入数が不足しています。",
  B050011_014: commonErrors.NOT_EXISTS_SHIRE,
  B050011_015: "{0} " + commonErrors.NOT_EXISTS_SHOHIN,
  B050011_016: "{0} " + commonErrors.NOT_EXISTS_SOKO,
  B050011_017: "{0} " + commonErrors.NOT_EXISTS_SHOHIN,
  B050011_018: commonErrors.NOT_EXISTS_SHIRE,
  B050011_019: "{0} " + commonErrors.NOT_EXISTS_TANKA,
  B050011_020: commonErrors.NOT_EXISTS_SHOHIZEI,
  B050011_021: commonErrors.NOT_EXISTS_SHAIN,
  B050011_022: commonErrors.NOT_EXISTS_SHOHIN,
  B050011_023: "{0} ロケーションコードが設定されていません。",
  B050011_024: "{0} 物理倉庫以外は設定できません。",
  B050020_001: "検索結果が0件です。",
  B050020_002: commonErrors.NOT_EXISTS_SHIREMEI,
  B050020_003: commonErrors.NOT_EXISTS_SHOHIZEI,
  B050020_004: commonErrors.NOT_EXISTS_TANKA,
  B050040_005: "権限IDが取得できませんでした。",
  B050020_006: commonErrors.NOT_EXISTS_KENGENTEIGI,
  B050020_007: "営業所コード(From)の値が不正です。",
  B050020_008: "営業所コード(To)の値が不正です。",
  B050030_001: commonErrors.EXCEEDED_OUTPUT_LIMIT,
  B050030_002: commonErrors.NOT_EXISTS_KENGENTEIGI,
  B050030_003: "営業所コード(From)の値が不正です。",
  B050030_004: "営業所コード(To)の値が不正です。",
  B050030_005: "Excel出力に失敗しました。",
  B050030_006: "商品中分類指定時は大分類も入力して下さい。",
  B050030_007: "商品小分類指定時は大分類も入力して下さい。",
  B050030_008: "商品小分類指定時は中分類も入力して下さい。",
  B050030_009: "権限IDが取得できませんでした。",
  B050030_010: "検索条件に一致するデータは存在しません。",
  B050030_011: commonErrors.NOT_EXISTS_NYUSHUTSURYOKU,
  B060010_001: commonErrors.CANNOT_OUTPUT,
  B060010_002: commonErrors.NOT_EXISTS_SEIZOSHIJI,
  B060010_003: commonErrors.NOT_EXISTS_NYUSHUTSURYOKU,
  B060010_004: commonErrors.EXCEEDED_OUTPUT_LIMIT,
  B060020_001: commonErrors.NOT_FOUND,
  B060020_002: commonErrors.NOT_EXISTS_SEIZOSHIJI,
  B060020_003: commonErrors.CANNOT_OUTPUT,
  B060020_004: commonErrors.NOT_EXISTS_NYUSHUTSURYOKU,
  B060020_005: commonErrors.EXCEEDED_OUTPUT_LIMIT,
  B060030_001: commonErrors.CANNOT_OUTPUT,
  B060030_002: commonErrors.NOT_FOUND,
  B060030_003: commonErrors.NOT_EXISTS_SEIZOSHIJI,
  B060030_004: commonErrors.NOT_EXISTS_NYUSHUTSURYOKU,
  B060030_005: commonErrors.EXCEEDED_OUTPUT_LIMIT,
  B070010_001: "EXCEL出力するデータが存在しません。",
  B070010_002: "EXCEL作成時にエラーが発生しました。",
  B070010_003: "一覧表示選択が入荷予定で、入荷予定日が入力されていません。",
  B070010_004: "一覧表示選択が入荷商品で、入荷日が選択されていません。",
  B070010_005: "EXCEL出力時は一覧表示選択に入荷商品を選択できません。",
  B070010_006: commonErrors.NOT_EXISTS_NYUSHUTSURYOKU,
  B070010_007: commonErrors.EXCEEDED_OUTPUT_LIMIT,
  B070020_001: commonErrors.NOT_EXISTS_SHOHIN + commonErrors.JuHachuNo,
  B070020_002:
    "入庫日が設定されていない仕入明細情報が存在します。" +
    commonErrors.JuHachuNo,
  B070020_003:
    "受注生産品の商品は完了取り消しできません。" + commonErrors.JuHachuNo,
  B070020_004:
    "完了区分は他の項目の修正を行えません。" + commonErrors.JuHachuNo,
  B070020_005:
    "在庫管理区分に「管理しない」が設定されている商品は入庫日を設定できません。" +
    commonErrors.JuHachuNo,
  B070020_006: commonErrors.NOT_EXISTS_NYUKAYOTEI + commonErrors.JuHachuNo,
  B070020_007: commonErrors.NOT_EXISTS_HACHU + commonErrors.JuHachuNo,
  B070020_008: commonErrors.NOT_EXISTS_HACHUMEI + commonErrors.JuHachuNo,
  B070020_009: "確定数がマイナスです。" + commonErrors.JuHachuNo,
  B070020_010: "入荷日を入力してください。" + commonErrors.JuHachuNo,
  B070020_011: "入荷予定日を入力してください。" + commonErrors.JuHachuNo,
  B070020_012: commonErrors.NOT_EXISTS_SHIRE + commonErrors.JuHachuNo,
  B070020_013: commonErrors.NOT_EXISTS_SHAIN + commonErrors.JuHachuNo,
  B070020_014: commonErrors.NOT_EXISTS_JUCHU + commonErrors.JuHachuNo,
  B070020_015: "過不足理由を入力してください。" + commonErrors.JuHachuNo,
  B070020_016: commonErrors.NOT_EXISTS_JUCHUMEI + commonErrors.JuHachuNo,
  B070020_017: commonErrors.NOT_EXISTS_HIKIATE + commonErrors.JuHachuNo,
  B070020_018: commonErrors.NOT_EXISTS_TANKA + commonErrors.JuHachuNo,
  B070020_019: commonErrors.NOT_EXISTS_UCHIWAKE + commonErrors.JuHachuNo,
  B070020_020:
    "仕入明細情報の最大値を取得できません。" + commonErrors.JuHachuNo,
  B070020_021: commonErrors.NOT_EXISTS_ZAIKO + commonErrors.JuHachuNo,
  B070020_022: commonErrors.NOT_EXISTS_TOKUI + commonErrors.JuHachuNo,
  B070020_023: "入庫日を入力してください。" + commonErrors.JuHachuNo,
  B070020_024:
    "ロケーションコードを入力してください。" + commonErrors.JuHachuNo,
  B070020_025: commonErrors.NOT_EXISTS_LOCATION + commonErrors.JuHachuNo,
  B070020_026: commonErrors.NOT_EXISTS_SHIREMEI + commonErrors.JuHachuNo,
  B070020_027:
    "受注伝票番号、発注伝票番号の両方が設定されていません。" +
    commonErrors.JuHachuNo,
  B070020_028:
    "仕入伝票番号、仕入行番号が設定されていません。" + commonErrors.JuHachuNo,
  B080010_001: "受注No.{0}はキャンセル済みのため、出荷予定を作成できません。",
  B080010_002: "受注No.{0}は受注確定済み以外のため、出荷予定を作成できません。",
  B080010_003:
    "受注No.{0} 明細No.{1} 構成No.{2} 商品CD{3}" +
    commonErrors.NOT_EXISTS_ZAIKO,
  B080010_004:
    "受注No.{0} 明細No.{1} 構成No.{2} " + commonErrors.NOT_EXISTS_LOCATION,
  B080010_005: "APJの得意納入先情報が存在しません。",
  B080020_001: commonErrors.NOT_EXISTS_SHUKABATCH,
  B080020_002: commonErrors.NOT_EXISTS_SHUKAYOTEI,
  B080020_003: commonErrors.NOT_EXISTS_SHUKAYOTEI,
  B080020_004: "出荷バッチ情報と出荷予定情報の出荷状況に差異があります。",
  B080020_005:
    "出荷バッチ情報が出荷確定済みのため、出荷バッチ情報を更新できません。",
  B080020_006:
    "出荷バッチ情報がキャンセル済みのため、出荷バッチ情報を更新できません。",
  B080020_007: commonErrors.CANNOT_OUTPUT,
  B080020_008: commonErrors.NOT_EXISTS_NYUSHUTSURYOKU,
  B080020_009: commonErrors.EXCEEDED_OUTPUT_LIMIT,
  B080020_010: commonErrors.NOT_EXISTS_JUCHUMEI,
  B080030_001: commonErrors.NOT_EXISTS_SHUKABATCH,
  B080030_002: "ピッキングリスト情報が存在しません。",
  B080030_003: commonErrors.CANNOT_OUTPUT,
  B080030_004: commonErrors.NOT_EXISTS_SHUKAYOTEI,
  B080030_005: "出荷バッチ情報と出荷予定情報の出荷状況に差異があります。",
  B080030_006:
    "出荷バッチ情報が出荷確定済みのため、出荷バッチ情報を更新できません。",
  B080030_007:
    "出荷バッチ情報がキャンセル済みのため、出荷バッチ情報を更新できません。",
  B080030_008: "キャンセル済みのため、出荷バッチ情報を更新できません。",
  B080030_009: commonErrors.NOT_EXISTS_NYUSHUTSURYOKU,
  B080030_010: commonErrors.EXCEEDED_OUTPUT_LIMIT,
  B080040_001: commonErrors.NOT_EXISTS_SHUKABATCH,
  B080040_002: "ピッキングリスト情報が存在しません。",
  B080040_003: commonErrors.CANNOT_OUTPUT,
  B080040_004: commonErrors.NOT_EXISTS_SHUKAYOTEI,
  B080040_005: "出荷バッチ情報と出荷予定情報の出荷状況に差異があります。",
  B080040_006: "出荷情報が出荷確定済みのため、出荷バッチ情報を更新できません。",
  B080040_007: "出荷情報が出荷確定済みのため、出荷バッチ情報を更新できません。",
  B080040_008:
    "出荷情報がキャンセル済みのため、出荷バッチ情報を更新できません。",
  B080040_009: commonErrors.NOT_EXISTS_NYUSHUTSURYOKU,
  B080040_010: commonErrors.EXCEEDED_OUTPUT_LIMIT,
  B080050_001: "出荷確定数は出荷予定数以下に設定して下さい。",
  B080050_002: commonErrors.NOT_EXISTS_SHUKAYOTEI,
  B080050_003: commonErrors.NOT_EXISTS_SHUKABATCH,
  B080060_001:
    commonErrors.NOT_EXISTS_SHUKABATCH +
    "出荷指示日:{0}, 指示回数:{1}, バッチ番号:{2}",
  B080060_002: commonErrors.NOT_EXISTS_SHUKAYOTEI,
  B080060_003:
    "売上明細構成情報が存在しません。" +
    "出荷指示日:{0}, 指示回数:{1}, バッチ番号:{2}",
  B080060_004:
    commonErrors.NOT_EXISTS_URIAGEMEI +
    "出荷指示日:{0}, 指示回数:{1}, バッチ番号:{2}",
  B080060_005:
    commonErrors.URIAGE + "出荷指示日:{0}, 指示回数:{1}, バッチ番号:{2}",
  B080060_006:
    commonErrors.NOT_EXISTS_JUCHU +
    "出荷指示日:{0}, 指示回数:{1}, バッチ番号:{2}",
  B080060_007:
    commonErrors.NOT_EXISTS_TOKUI +
    "出荷指示日:{0}, 指示回数:{1}, バッチ番号:{2}",
  B080060_008:
    commonErrors.NOT_EXISTS_SHOHIZEI +
    "出荷指示日:{0}, 指示回数:{1}, バッチ番号:{2}",
  B080060_009:
    commonErrors.NOT_EXISTS_SOKO +
    "出荷指示日:{0}, 指示回数:{1}, バッチ番号:{2}",
  B080060_010:
    commonErrors.NOT_EXISTS_HIKIATE +
    "出荷指示日:{0}, 指示回数:{1}, バッチ番号:{2}",
  B080060_011:
    commonErrors.NOT_EXISTS_SHOHIN +
    "出荷指示日:{0}, 指示回数:{1}, バッチ番号:{2}",
  B080060_012:
    commonErrors.NOT_EXISTS_ZAIKO +
    "出荷指示日:{0}, 指示回数:{1}, バッチ番号:{2}",
  B080070_001: commonErrors.CANNOT_OUTPUT,
  B080070_002: commonErrors.NOT_EXISTS_NYUSHUTSURYOKU,
  B080070_003: commonErrors.EXCEEDED_OUTPUT_LIMIT,
  B080090_001: commonErrors.NOT_FOUND,
  B080090_002: "取込先が正しく選択されていません。",
  B080090_003: commonErrors.CANNOT_OUTPUT,
  B080090_004: commonErrors.NOT_EXISTS_NYUSHUTSURYOKU,
  B080090_005: commonErrors.EXCEEDED_OUTPUT_LIMIT,
  B090010_001: commonErrors.NOT_FOUND,
  B090010_002: commonErrors.CANNOT_OUTPUT,
  B090010_003: "商品、JANコード、倉庫、倉庫種別のいずれかを入力してください。",
  B090010_004: "倉庫コードと倉庫種別区分はどちらか一方を選択してください。",
  B090010_005: commonErrors.NOT_EXISTS_SOKO,
  B090010_006: "物理倉庫以外の倉庫を入力してください。",
  B090010_007: commonErrors.NOT_EXISTS_NYUSHUTSURYOKU,
  B090010_008: commonErrors.EXCEEDED_OUTPUT_LIMIT,
  B090011_001: commonErrors.NOT_FOUND,
  B090011_002: commonErrors.CANNOT_OUTPUT,
  B090011_003: commonErrors.NOT_EXISTS_SOKO,
  B090011_004: "物理倉庫以外の倉庫コードは入力できません。",
  B090011_005: commonErrors.NOT_EXISTS_NYUSHUTSURYOKU,
  B090011_006: commonErrors.EXCEEDED_OUTPUT_LIMIT,
  B090020_001: "払出倉庫情報が存在しません。",
  B090020_002: "受入倉庫情報が存在しません。",
  B090020_003: "明細を登録して下さい。",
  B090020_004: "払出倉庫と受入倉庫で同じ倉庫を入力しています。",
  B090020_005: "払出倉庫は論理倉庫、または引当倉庫を入力して下さい。",
  B090020_006: "受入倉庫は論理倉庫、または引当倉庫を入力して下さい。",
  B090020_007: "払出倉庫、受入倉庫の両方に引当倉庫を入力できません。",
  B090020_008: "移動数は１件以上を入力して下さい。",
  B090020_009: "移動数は可能数以下を入力して下さい。",
  B090020_010: "払出倉庫の商品に引当情報が存在しません。",
  B090020_011: commonErrors.NOT_EXISTS_SOKO,
  B090020_012: "倉庫情報の設定に不備があります。",
  B090020_013: commonErrors.NOT_EXISTS_HIKIATE,
  B090021_001: "払出ロケーション管理情報が存在しません。",
  B090021_002: "受入倉庫情報が存在しません。",
  B090021_003: "明細を登録して下さい。",
  B090021_004: "受入倉庫は返品倉庫、またはその他倉庫を入力して下さい。",
  B090021_005: "移動数は１件以上を入力して下さい。",
  B090021_006: "移動数は可能数以下を入力して下さい。",
  B090021_007: "払出在庫情報が存在しません。",
  B090021_008: "受入在庫情報が存在しません。",
  B090030_001: "明細を登録して下さい。",
  B090030_002: "払出倉庫と受入倉庫で同じ倉庫を選択しています。",
  B090030_003: "移動数は１件以上を入力して下さい。",
  B090030_004: "移動数は可能数以下を入力して下さい。",
  B090030_005: "払出ロケーション管理情報が存在しません。",
  B090030_006: "受入ロケーション管理情報が存在しません。",
  B090030_007: commonErrors.NOT_EXISTS_SOKO,
  B090030_008: commonErrors.NOT_EXISTS_HIKIATE,
  B090040_001: "明細を登録して下さい。",
  B090040_002: commonErrors.NOT_EXISTS_SOKO,
  B090040_003:
    "倉庫には物理倉庫、材料倉庫、返品倉庫、その他倉庫を入力して下さい。",
  B090040_004:
    "入力した物理倉庫に対してロケーションコードが設定されていません。",
  B090040_005: "調整数がマイナスです。",
  B090040_006: commonErrors.NOT_EXISTS_ZAIKO,
  B090040_007: commonErrors.NOT_EXISTS_HIKIATE,
  B090050_001: commonErrors.NOT_FOUND,
  B090050_002: commonErrors.CANNOT_OUTPUT,
  B090050_003: commonErrors.INVALID_DATE,
  B090050_004: commonErrors.NOT_EXISTS_NYUSHUTSURYOKU,
  B090050_005: commonErrors.EXCEEDED_OUTPUT_LIMIT,
  B090050_006: commonErrors.NOT_EXISTS_SOKO,
  B090050_007: "物理倉庫以外を選択して下さい。",
  B090051_001: commonErrors.NOT_FOUND,
  B090051_002: commonErrors.CANNOT_OUTPUT,
  B090051_003: commonErrors.INVALID_DATE,
  B090051_004: commonErrors.NOT_EXISTS_NYUSHUTSURYOKU,
  B090051_005: commonErrors.EXCEEDED_OUTPUT_LIMIT,
  B090051_006: commonErrors.NOT_EXISTS_SOKO,
  B090051_007: "論理倉庫、引当倉庫以外を選択して下さい。",
  B090060_001: "払出倉庫情報が存在しません。",
  B090060_002: "受入倉庫情報が存在しません。",
  B090060_003: "払出ロケーション管理情報が存在しません。",
  B090060_004: "受入倉庫情報が存在しません。",
  B090060_005: "倉庫には返品倉庫、またはその他倉庫を入力して下さい。",
  B090060_006: "選択されたファイルがエクセルファイルではありません。",
  B090060_007: "ファイルの取込に失敗しました。",
  B090060_008: "ヘッダー行またはデータ行が存在しません。",
  B090060_009: "ヘッダー行の項目数が不正です。",
  B090060_010: "ヘッダー行の名称に不正なものがあります。",
  B090060_011: "シートが複数存在します。",
  B090060_012: commonErrors.NOT_EXISTS_NYUSHUTSURYOKU,
  B090060_013: commonErrors.EXCEEDED_INPUT_LIMIT,

  B100040_001: "入力された部門コードはすでに使用されています。",
  B100040_002: "入力された部門コードの部門情報は存在しません。",
  B100040_003: commonErrors.NOT_EXISTS_BUMON,
  B100050_001: "入力された社員コードはすでに使用されています。",
  B100050_002: "入力された社員コードの社員情報は存在しません。",

  B100060_001:
    "入力された得意先コードと得意先支店コードはすでに使用されています。",
  B100060_002:
    "入力された請求先コードと請求先支店コードの請求先情報は存在しません。",
  B100060_003: "得意先コードと請求先コードが一致しません。",
  B100060_004: "得意先支店コードと請求先支店コードが一致しません。",
  B100060_005:
    "入力された売掛先コードと売掛先支店コードの売掛先情報は存在しません。",
  B100060_006: "得意先コードと売掛先コードが一致しません。",
  B100060_007: "得意先支店コードと売掛先支店コードが一致しません。",
  B100060_008: commonErrors.NOT_EXISTS_TOKUI,
  B100060_009: commonErrors.NOT_EXISTS_TOKUI,
  B100063_001: commonErrors.EXCEEDED_OUTPUT_LIMIT,
  B100063_002: "Excel出力に失敗しました。",
  B100063_003: commonErrors.NOT_EXISTS_NYUSHUTSURYOKU,
  B100070_001: commonErrors.NOT_EXISTS_TOKUI,
  B100070_002: "納入先が登録されていません。新規登録を行ってください。",
  B100070_003: "入力された納入先はすでに使用されています。",
  B100070_004:
    "他のユーザが更新した可能性があります、最新の情報を確認してください。",
  B100073_001: commonErrors.EXCEEDED_OUTPUT_LIMIT,
  B100073_002: "Excel出力に失敗しました。",
  B100073_003: commonErrors.NOT_EXISTS_NYUSHUTSURYOKU,
  B100080_001: "入力された仕入先コードはすでに使用されています。",
  B100080_002: commonErrors.NOT_FOUND,
  B100080_003: "取引終了年月日に取引開始年月日より前の日付が設定されています。",
  B100080_004: "仕入先情報が存在しません。",
  B100083_001: commonErrors.EXCEEDED_OUTPUT_LIMIT,
  B100083_002: "Excel出力に失敗しました。",
  B100083_003: commonErrors.NOT_EXISTS_NYUSHUTSURYOKU,
  B100100_001: "入力された倉庫コードはすでに使用されています。",
  B100100_002: "入力された倉庫コードの倉庫情報は存在しません。",
  B100100_003: commonErrors.NOT_EXISTS_SOKO,
  B100110_001: commonErrors.NOT_FOUND,
  B100110_003: "材料品の商品情報が存在しません。",
  B100110_004: "材料品コードに材料品以外の商品を入力することは出来ません。",
  B100110_005: "商品中分類指定時は大分類も入力して下さい。",
  B100110_006: "商品小分類指定時は大分類と中分類も入力して下さい。",
  B100110_007: commonErrors.NOT_EXISTS_SHOBUNRUI,
  B100110_008: commonErrors.NOT_EXISTS_CHUBUNRUI,
  B100110_009: commonErrors.NOT_EXISTS_DAIBUNRUI,
  B100110_010: commonErrors.NOT_EXISTS_SHOHIN,
  B100110_011: commonErrors.NOT_EXISTS_SHOHIN,
  B100113_001: commonErrors.EXCEEDED_OUTPUT_LIMIT,
  B100113_002: "Excel出力に失敗しました。",
  B100113_003: commonErrors.NOT_EXISTS_NYUSHUTSURYOKU,
  B100120_001: "商品分類が 商品中分類の場合、商品中分類コードは必須入力です。",
  B100120_002: "商品分類が 商品小分類の場合、商品中分類コードは必須入力です。",
  B100120_003: "商品分類が 商品小分類の場合、商品小分類コードは必須入力です。",
  B100120_004: "入力された商品大分類コードはすでに登録されています。",
  B100120_005: commonErrors.NOT_EXISTS_DAIBUNRUI,
  B100120_006:
    "入力された商品大分類コード、商品中分類コードはすでに登録されています。",
  B100120_007: commonErrors.NOT_EXISTS_CHUBUNRUI,
  B100120_008:
    "入力された商品大分類コード、商品中分類コード、商品小分類コードはすでに登録されています。",
  B100120_009: commonErrors.NOT_EXISTS_SHOBUNRUI,
  B100120_010: "対象の商品大分類情報が商品マスタで使用中のため削除できません。",
  B100120_011: "対象の商品中分類情報が商品マスタで使用中のため削除できません。",
  B100120_012: "対象の商品小分類情報が商品マスタで使用中のため削除できません。",
  B100133_001: commonErrors.EXCEEDED_OUTPUT_LIMIT,
  B100133_002: "Excel出力に失敗しました。",
  B100133_003: commonErrors.NOT_EXISTS_NYUSHUTSURYOKU,
  B100130_001: commonErrors.NOT_EXISTS_SHOHIN,
  B100130_002: "セット品ではないため検索できません。",
  B100130_003: "構成品が登録されていません。明細登録を行ってください。",
  B100130_004: "セット商品コードの商品情報が存在しません。",
  B100130_005:
    "セット商品コードにセット品以外の商品が入力されているため、登録することができません。",
  B100130_006: "明細{0}行目 商品情報が存在しません。",
  B100130_007: "明細{0}行目 セット品は登録することができません。",
  B100130_008: "明細{0}行目 構成数には0より大きい値を入力してください。",
  B100130_009: "明細{0}行目 外寸が入力されていません。",
  B100130_010: "明細{0}行目 外寸には0より大きい値を入力してください。",
  B100130_011:
    "検索ボタンを押下して、最新の情報を確認後に更新を行ってください。",
  B100140_001: "検索条件に一致するデータは存在しません。",
  B100140_002: "単価区分に通常売上と仕入以外は設定できません。",
  B100140_003:
    "入力された単価区分、商品コード、期間開始はすでに単価マスタに登録されています。",
  B100140_004:
    "入力された単価区分、商品コード、期間開始はすでに原価マスタに登録されています。",
  B100140_005: "単価区分が通常売上の場合、原価は必須入力です。",
  B100140_006: commonErrors.NOT_EXISTS_TANKA,
  B100140_007: commonErrors.NOT_EXISTS_GENKA,
  B100140_008:
    "他のユーザが更新した可能性があります、最新の情報を確認してください。",
  B100140_009: "削除対象の情報が取得できませんでした。",
  B100140_010: commonErrors.NOT_EMPTY,
  B100140_011:
    "登録可能な期間よりも、過去の日付が入力されました。再度入力し直してください。",
  B100140_012:
    "登録可能な期間よりも、未来の日付が入力されました。再度入力し直してください。",
  B100143_001: commonErrors.EXCEEDED_OUTPUT_LIMIT,
  B100143_002: "Excel出力に失敗しました。",
  B100143_003: commonErrors.NOT_EXISTS_NYUSHUTSURYOKU,
  B100143_005: "単価区分は通常売上、仕入、または全件を選択して下さい。",
  B100150_001: "検索条件に一致するデータは存在しません。",
  B100150_002: "入力された条件のデータはすでに存在します。",
  B100150_003: "取引先別単価情報が存在しません。",
  B100150_004:
    "他のユーザが更新した可能性があります、最新の情報を確認してください。",
  B100150_005:
    "登録可能な期間よりも、過去の日付が入力されました。再度入力し直してください。",
  B100150_006:
    "登録可能な期間よりも、未来の日付が入力されました。再度入力し直してください。",
  B100153_001: commonErrors.EXCEEDED_OUTPUT_LIMIT,
  B100153_002: "Excel出力に失敗しました。",
  B100153_003: commonErrors.NOT_EXISTS_NYUSHUTSURYOKU,
  B100180_001: "入力されたコードは存在しません。",
  B100180_002: "該当データは既に登録済みです。",
  B100180_003: "該当データが存在しません。",
  B100180_004:
    "他のユーザが更新した可能性があります、最新の情報を確認してください。",
  B100180_005:
    "他のユーザが更新した可能性があります、最新の情報を確認してください。",
  B100180_006:
    "他のユーザが更新した可能性があります、最新の情報を確認してください。",
  B100183_001: commonErrors.EXCEEDED_OUTPUT_LIMIT,
  B100183_002: "Excel出力に失敗しました。",
  B100183_003: commonErrors.NOT_EXISTS_NYUSHUTSURYOKU,
  B100183_004: "WH単価区分には0か1か2のいずれかの値を設定してください。",
  B100190_001: commonErrors.NOT_EXISTS_LOCATION,
  B100190_002: "入力された条件のデータはすでに存在します。",
  B100190_003:
    "他のユーザが更新した可能性があります、最新の情報を確認してください。",
  B100190_004: "検索条件に一致するデータは存在しません。",
  B100190_005: commonErrors.NOT_EXISTS_ZONE,
  B100193_001: commonErrors.EXCEEDED_OUTPUT_LIMIT,
  B100193_002: "Excel出力に失敗しました。",
  B100193_003: commonErrors.NOT_EXISTS_NYUSHUTSURYOKU,
  B100220_001: "入力された条件のデータはすでに存在します。",
  B100220_002: commonErrors.NOT_EXISTS_HAISOROUTEASS,
  B100220_003:
    "他のユーザが更新した可能性があります、最新の情報を確認してください。",
  B100220_004: "検索条件に一致するデータは存在しません。",
  B100223_001: commonErrors.EXCEEDED_OUTPUT_LIMIT,
  B100223_002: "Excel出力に失敗しました。",
  B100223_003: commonErrors.NOT_EXISTS_NYUSHUTSURYOKU,
  B100230_001: "入力された条件のデータはすでに存在します。",
  B100230_002: commonErrors.NOT_EXISTS_HAISOROUTEBATCH,
  B100900_001: "選択されたファイルがエクセルファイルではありません。",
  B100900_002: "シートが複数存在します。",
  B100900_003: "ファイルの取込に失敗しました。",
  B100900_004: "ヘッダー行またはデータ行が存在しません。",
  B100900_005: "ヘッダー行の項目数が不正です。",
  B100900_006: "ヘッダー行の名称に不正なものがあります。",
  B100900_007: commonErrors.NOT_EXISTS_NYUSHUTSURYOKU,
  B100900_008: commonErrors.EXCEEDED_INPUT_LIMIT,
  B100910_001: "機能情報の取得に失敗しました。画面を再読み込みしてください。",
  B100910_002: "Excel出力に失敗しました。",
  B110010_001: commonErrors.NOT_EXISTS_SYSTEM,
  B110010_002: "すでに月次処理の予約または実行中です。",
  B110010_003: "現在年月以降の本締めはできません。",
  B110020_001: commonErrors.NOT_FOUND,
  B110020_002: commonErrors.NOT_EXISTS_NYUSHUTSURYOKU,
  B110020_003: commonErrors.EXCEEDED_OUTPUT_LIMIT,
  B110020_004: commonErrors.CANNOT_OUTPUT,
  B110020_005: commonErrors.NOT_EXISTS_EIGYO,
  B110020_006: "得意先分類1が存在しません。",
  B110020_007: "得意先分類2が存在しません。",
  B110020_008: commonErrors.INVALID_DATE,
  B110030_001: commonErrors.CANNOT_OUTPUT,
  B110030_002: "出力形式、または取引区分を設定して下さい。",
  B110030_003: commonErrors.NOT_FOUND,
  B110030_004: commonErrors.NOT_EXISTS_NYUSHUTSURYOKU,
  B110030_005: commonErrors.EXCEEDED_OUTPUT_LIMIT,
  B110030_006: "伝票日付は同月内で指定してください。",
  B110040_001: "エクセルは１シートにしてください。",
  B110040_002: "エクセルファイルを指定してください。",
  B110040_003: "エクセルファイルが読み込めませんでした。",
  B110040_004: "エクセルの1行目は項目名を設定してください。",
  B110040_005: "エクセルの1行目の項目名が正しくありません。",
  B110040_006: "エクセルの項目名に誤りがあります。",
  B110040_007: commonErrors.NOT_EXISTS_NYUSHUTSURYOKU,
  B110040_008: commonErrors.EXCEEDED_INPUT_LIMIT,
};
